import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

import config from "appConfig";

const items = [
  {
    id: "fa206d91-260b-407c-8f86-f301ea439b50",
    options: { image: `${config.ASSETS_URL}/03/19/task/task-02-item-01.svg` },
  },
  {
    id: "e75a7615-2557-4fef-b59f-1589b68aa9e9",
    options: { image: `${config.ASSETS_URL}/03/19/task/task-02-item-02.svg` },
  },
  {
    id: "cccff60d-f337-4136-b1cf-4503e1724057",
    options: { image: `${config.ASSETS_URL}/03/19/task/task-02-item-03.svg` },
  },
  {
    id: "1f4dea58-4ada-4302-ba76-e9263f1ac28f",
    options: { image: `${config.ASSETS_URL}/03/19/task/task-02-item-04.svg` },
  },
];

export const task: Task = {
  id: "36cfbcea-b4ac-4c66-954f-fd306263cde4",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["fa206d91-260b-407c-8f86-f301ea439b50"],
};
